import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_AGREEMENT_URL } from "../constants"
import { IAgreementResponse, IErrorResponse } from "../interface"
import { RootState } from "../../store/store"
import { axios } from "../axios"

const getAgreement = async (token: string | null) => {
  const response = await axios(API_AGREEMENT_URL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const useAgreement = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IAgreementResponse, IErrorResponse>({
    queryKey: ["agreement", token],
    queryFn: () => getAgreement(token),
    enabled: Boolean(token),
    refetchInterval: false,
    refetchOnWindowFocus: false,
  })
}
